import { render, staticRenderFns } from "./BaseImageView.vue?vue&type=template&id=3dd5c10f&"
import script from "./BaseImageView.vue?vue&type=script&lang=js&"
export * from "./BaseImageView.vue?vue&type=script&lang=js&"
import style0 from "./BaseImageView.vue?vue&type=style&index=0&id=3dd5c10f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports